var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectPlaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M1913.359,274.676h-5.888a.589.589,0,0,0-.589.589v4.121h-5.3a.589.589,0,0,0-.589.589V284.1h-5.3a.589.589,0,0,0-.589.589v8.244a.589.589,0,0,0,.589.589h17.664a.589.589,0,0,0,.589-.589V275.265A.589.589,0,0,0,1913.359,274.676Zm-12.365,17.665h-4.711v-7.066h4.711Zm5.888,0h-4.71V280.564h4.71Zm5.888,0h-4.71V275.854h4.71Z",
    transform: "translate(-1892.858 -272.292)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPlaning);
export default __webpack_public_path__ + "static/media/ProjectPlaning.13ab1b9b.svg";
export { ForwardRef as ReactComponent };